import React, { useState } from 'react'
import { Button } from '@habitech/call-to-action';
import { methodsName, OneClickOrigin, OriginPayment, payment_method, SourceShoppingCart } from 'src/constants/ShoppingCart';
import { useAppSelector } from 'src/hooks/redux';
import { selectUser } from 'src/redux/user/userSlice';
import { paymentOneClick } from 'src/apis/paymentOneClick';
import Modal from '../common/modal/Modal';
import { WrapperError, WrapperModaPaymentOneClick } from './ButtonPaymentOneClick.styles';
import { TextField } from '@habitech/keychain-atoms-inputs';

export interface DataPaymentOneClick {
  total: number;
  description: string;
  detail: string;
  buttonDisabled: boolean;
  user_id: number;
  type_payment?: any
}

const ButtonPaymentOneClick = ({
  total,
  description,
  detail,
  buttonDisabled,
  user_id, 
  type_payment
}: DataPaymentOneClick) => {

  const { token } = useAppSelector(selectUser);
  const [dataModal, setdataModal] = useState({
    order: "",
    url: ""
  });
  const [error, setError] = useState("");
  const [lodingPayment, setlodingPayment] = useState(false)
  const [showModalSummary, setShowModalSummary] = useState(false);

  const handlePaymentOneClick = async () => {
    setlodingPayment(true)
    setError("")
    const ivaRate = 0.16;
    // Calcular subtotal sin IVA
    const sub_total = total / (1 + ivaRate);
    // Calcular IVA
    const iva = total - sub_total;
    const data = {
      country: "MX",
      sub_total: sub_total,
      iva: iva,
      payment_method: type_payment,
      card_id: "",
      total: total,
      description: description,
      device_session_id: "pago_en_un_click",
      one_click: true,
      source: SourceShoppingCart.CART_V3,
      detail: detail,
      user_id: user_id,
      one_click_origin: OneClickOrigin.CALCULADORA,
      origin: OriginPayment.INT,
      cvv2: "",
    };
    const response = await paymentOneClick(data, token)
    if (response.status === 200) {
      if(
        type_payment === payment_method[methodsName.CARD_3DS] ||
        type_payment === payment_method[methodsName.CARD]
      ){
        setdataModal({
          order:response.response.results.order_id,
          url: response.response.results.redirect
        })
      }else{
        setdataModal({
          order:response.response.results.order_id,
          url: response.response.results.url_pdf
        })
      }
      
      setShowModalSummary(true)
    } else {
      const errorJson = JSON.parse(response.response.message)
      setError(errorJson.message)
    }
    setlodingPayment(false)
  }

  const handleCloseModal = () => {
    navigator.clipboard.writeText(dataModal.url)
    setShowModalSummary(false)
  }


  return (
    <>
      <Button
        dataId="btn_paymen_one_click"
        onClick={handlePaymentOneClick}
        originType="pcom"
        size="large"
        disabled={buttonDisabled}
        loading={lodingPayment}
      >
        Crear Pago
      </Button>
      <WrapperError>
        {error}
      </WrapperError>
      {
        showModalSummary &&
        <Modal onClose={handleCloseModal}>
          <WrapperModaPaymentOneClick>
            <h1>Orden de pago creada.</h1>
            <p>Información de la orden creada.</p>
            <p>
              <b>Order:</b> {dataModal.order}
            </p>
            <div className='WrapperUrl'>
              <TextField
                label='URL'
                dataId="name"
                name="name"
                originType="pcom"
                innerLabel
                value={dataModal.url}
                disabled={true}
              />
              <button
                className='btnCopy'
                data-testid="Copiar"
                onClick={() => navigator.clipboard.writeText(dataModal.url)}
              >
                Copiar
              </button>
            </div>
            <Button
              dataId="aceptar"
              onClick={handleCloseModal}
              originType="pcom"
              size="extra-large"
              fluid
            >
              Aceptar y copiar
            </Button>
          </WrapperModaPaymentOneClick>
        </Modal>
      }

    </>
  )
}

export default ButtonPaymentOneClick
